import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';

import { EmailBasicDto, EmailThreadSummaryItemDto } from '@/api/generated';
import { formatDate } from '@/utils/formatDate.util.ts';

type Props = {
  email: EmailBasicDto | EmailThreadSummaryItemDto;
};

export const EmailSummaryAttachmentsAndDate: React.FC<Props> = props => {
  const { email } = props;

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ alignItems: 'flex-start', flex: 0, justifyContent: 'flex-end' }}
    >
      {email.attachments.length > 0 && <AttachFileOutlinedIcon />}
      <Typography sx={DateSx} variant="f12Regular">
        {formatDate(email.date, { withTime: true })}
      </Typography>
    </Stack>
  );
};

const DateSx = { textAlign: 'center', whiteSpace: 'nowrap' };
